import React, { createContext, useContext, useState, useEffect } from 'react';
import enTranslations from '../i18n/en.json';
import srTranslations from '../i18n/sr.json';

type Language = 'en' | 'sr';

interface LanguageContextType {
  language: Language;
  setLanguage: (lang: Language) => void;
  t: (key: string, params?: Record<string, string | number>) => string;
}

const translations = {
  en: enTranslations,
  sr: srTranslations
} as const;

const LanguageContext = createContext<LanguageContextType>({} as LanguageContextType);

export const LanguageProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [language, setLanguage] = useState<Language>(() => {
    const savedLanguage = localStorage.getItem('language');
    return (savedLanguage === 'en' || savedLanguage === 'sr') ? (savedLanguage as Language) : 'sr';
  });

  useEffect(() => {
    localStorage.setItem('language', language);
  }, [language]);

    const t = (key: string, params?: Record<string, string | number>) => {
        const keys = key.split('.');
        let value: any = translations[language];

        for (const k of keys) {
            if (value && typeof value === 'object' && k in value) {
                value = value[k];
            } else {
                return key;
            }
        }

        if (typeof value === 'string' && params) {
            Object.entries(params).forEach(([paramKey, paramValue]) => {
                // podržava {{param}} sintaksu
                value = value.replace(new RegExp(`{{\\s*${paramKey}\\s*}}`, 'g'), String(paramValue));
            });
        }

        return typeof value === 'string' ? value : key;
    };



    return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);